var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-tw",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillRule: "nonzero",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C5.37375,0 0,5.37375 0,12 C0,18.62625 5.37375,24 12,24 C18.62625,24 24,18.62625 24,12 C24,5.37375 18.62625,0 12,0 Z M17.47875,9.35625 C17.48475,9.47475 17.48625,9.59325 17.48625,9.7125 C17.48625,13.35225 14.7165,17.54925 9.65025,17.54925 C8.09475,17.54925 6.64725,17.09325 5.42775,16.31175 C5.64375,16.33725 5.86275,16.34925 6.0855,16.34925 C7.3755,16.34925 8.5635,15.90975 9.50625,15.171 C8.30025,15.1485 7.284,14.352 6.93375,13.2585 C7.101,13.29 7.2735,13.30725 7.45125,13.30725 C7.7025,13.30725 7.94625,13.2735 8.17725,13.2105 C6.91725,12.9585 5.96775,11.84475 5.96775,10.5105 L5.96775,10.47525 C6.339,10.68225 6.76275,10.806 7.215,10.82025 C6.4755,10.32675 5.9895,9.483 5.9895,8.5275 C5.9895,8.02275 6.126,7.5495 6.36225,7.143 C7.7205,8.8095 9.75075,9.90525 12.03975,10.02075 C11.9925,9.81825 11.9685,9.60825 11.9685,9.393 C11.9685,7.872 13.20225,6.63825 14.72325,6.63825 C15.51525,6.63825 16.23075,6.9735 16.73325,7.50825 C17.361,7.38525 17.9505,7.15575 18.48225,6.84075 C18.27675,7.4835 17.84025,8.02275 17.271,8.36325 C17.82825,8.29725 18.35925,8.1495 18.8535,7.92975 C18.4845,8.4825 18.0165,8.96775 17.47875,9.35625 L17.47875,9.35625 Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTw);
export default __webpack_public_path__ + "static/media/icon-tw.21713081.svg";
export { ForwardRef as ReactComponent };